import React, { createRef, useEffect } from "react"
import Row from "react-bootstrap/Row"
import Container from "react-bootstrap/Container"
import Col from "react-bootstrap/Col"
import Layout from "../components/layout"
import Seo from "../components/SEO"
import * as indexStyles from "./index.module.scss"
import { graphql, useStaticQuery } from "gatsby"
import "bootstrap/dist/css/bootstrap.min.css"
import lottie from "lottie-web"
import animation from "./../../static/Developer.json"
import { LazyLoadImage } from "react-lazy-load-image-component"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import { StaticImage } from "gatsby-plugin-image"

import DownloadOnAppStore from "./../../static/download-on-appstore.svg"
import DownloadOnPlayStore from "./../../static/google-play-badge.png"
import BlogPostListItem from "../components/blogPostListItem"
import NewsLetterFooter from "../components/newsLetter"

const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulBlogPost(
        sort: { fields: publishedDate, order: DESC }
        limit: 3
      ) {
        edges {
          node {
            title
            slug
            publishedDate(formatString: "MMMM Do, YYYY")
            excerpt
            category
          }
        }
      }
    }
  `)

  const animationContainer = createRef()

  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: animationContainer.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animation,
    })
    anim.setSubframe(false)
    return () => anim.destroy() // optional clean up for unmounting
  }, [])

  return (
    <Layout>
      <Seo title="Home" />

      <section className={indexStyles.jumbo}>
        <Container className={indexStyles.jumboContent}>
          <Row>
            <Col
              lg={{ span: 5, order: 1 }}
              xs={{ span: 12, order: 2 }}
              md={{ span: 12, order: 2 }}
            >
              <h1 className={indexStyles.jumboTitle}>
                Hi, I’m Jeff and I'm a Fullstack Developer
              </h1>
              <p className={indexStyles.jumboSubTitle}>
                Subscribe to my newsletter to get the best React, Javascript,
                and Typescript tutorials in your inbox. Zero spam & able to
                unsubscribe at anytime.
              </p>
              <div className={indexStyles.jumboButtonContainer}>
                <NewsLetterFooter />
              </div>
            </Col>
            <Col
              lg={{ span: 7, order: 2 }}
              xs={{ span: 12, order: 1 }}
              md={{ span: 12, order: 1 }}
            >
              <div
                className={indexStyles.jumboImage}
                ref={animationContainer}
              />
            </Col>
          </Row>
        </Container>
      </section>

      <section className={indexStyles.bouncyArrowContainer}>
        <AnchorLink to="/#recent-blog-posts" className={indexStyles.anchorLink}>
          <i className={indexStyles.downArrow}></i>
        </AnchorLink>
      </section>

      <section className={indexStyles.recentBlogPosts} id="recent-blog-posts">
        <Container>
          <h2 className={indexStyles.subTitle}>Recent Blog Posts</h2>
          <div className={indexStyles.separator}></div>

          {data.allContentfulBlogPost.edges.map(edge => {
            return <BlogPostListItem edge={edge} key={edge.node.slug} />
          })}
        </Container>
      </section>

      <section className={indexStyles.recentWork} id="recent-work">
        <Container>
          <h2 className={indexStyles.subTitle}>My Recent Work</h2>
          <div className={indexStyles.separator}> </div>

          <Row className="align-items-center text-center">
            <Col md={4}>
              <div className={indexStyles.recentWorkImageContainer}>
                <StaticImage
                  alt={"Daily Discomfort Project"}
                  className={indexStyles.recentWorkImage}
                  src="../../static/Project-Images/DailyDiscomfort.png"
                  placeholder="blurred"
                />
              </div>
            </Col>

            <Col md={8}>
              <div style={{ justifyContent: "center" }}>
                <h2 className={indexStyles.recentWorkItemTitle}>
                  Daily Discomfort
                </h2>
              </div>

              <p className={indexStyles.recentWorkItemDescription}>
                Daily Discomfort was created to get people out of their comfort
                zone by completing various user submitted challenges designed to
                cause discomfort. The frontend of this application was created
                using React Native and the backend was created using NodeJS and
                MongoDB for the database.
              </p>

              <div className={indexStyles.recentWorkButtonContainer}>
                <a href="https://apps.apple.com/us/app/daily-discomfort/id1535108054">
                  <LazyLoadImage
                    alt={"Daily Discomfort iOS Download Link Image"}
                    src={DownloadOnAppStore}
                  />
                </a>

                <a href="https://play.google.com/store/apps/details?id=com.jeffedmondson.dailydiscomfort">
                  <LazyLoadImage
                    alt={"Daily Discomfort Android Download Link Image"}
                    style={{ height: "3.655em" }}
                    src={DownloadOnPlayStore}
                  />
                </a>
              </div>
            </Col>
          </Row>

          <Row className="align-items-center text-center mx-auto my-auto">
            <Col xs={{ span: 12, order: 2 }} md={8} lg={8}>
              <h3 className={indexStyles.recentWorkItemTitle}>Funny Weather</h3>

              <p className={indexStyles.recentWorkItemDescription}>
                Weather just got a whole lot funnier! Funny Weather gives you a
                funny, user submitted phrase, with your normal weather forecast.
                Co-created a native Swift and Kotlin application with a NodeJs
                backed.
              </p>

              <div className={indexStyles.recentWorkButtonContainer}>
                <a href="https://apps.apple.com/us/app/funny-weather-rude-forecasts/id1499583238">
                  <LazyLoadImage
                    alt={"Funny Weather iOS Download Link Image"}
                    src={DownloadOnAppStore}
                  />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.epsilonv.funnyweather">
                  <LazyLoadImage
                    alt={"Funny Weather Android Download Link Image"}
                    style={{ height: "3.655em" }}
                    src={DownloadOnPlayStore}
                  />
                </a>
              </div>
            </Col>

            <Col
              xs={{ span: 12, order: 1 }}
              md={{ span: 4, order: 2 }}
              style={{ marginTop: "3em" }}
            >
              <div className={indexStyles.recentWorkImageContainer}>
                <StaticImage
                  alt={"Daily Discomfort Project"}
                  className={indexStyles.recentWorkImage}
                  src="../../static/Project-Images/FunnyWeather.png"
                  placeholder="blurred"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Layout>
  )
}

export default IndexPage
